<div class="display-grid">
  <app-input [label]="'PersonalData.FirstName' | translate" [form]="form.get('firstName')"></app-input>
  <app-input [label]="'PersonalData.LastName' | translate" [form]="form.get('lastName')"></app-input>
  <app-input [label]="'PersonalData.Post' | translate" [form]="form.get('post')"></app-input>
  <app-input [label]="'PersonalData.Email' | translate" [form]="form.get('email')"></app-input>
  <mat-checkbox *ngIf="!alwaysSuperEmployee" [formControl]="form.get('isSuperEmployee')">{{
    'PersonalData.IsSuperEmployee' | translate
  }}</mat-checkbox>
</div>
